import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  autocomplete: {
    '.MuiChip-label': {
      textTransform: 'uppercase'
    }
  }
}));

export default useStyles;
